enum KycStatusType {
  VERIFIED = 1,
  REQUESTED = 2,
  UNDER_REVIEW = 3,
  UNVERIFIED = 4,
  FAILED = 5,
}

export default KycStatusType
